<style lang="scss" scoped>
  .initials {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f6f5f8;
    font-family: Montserrat;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: -0.17px;
    line-height: 30px;

    &.inline {
      display: inline;
      line-height: 0px;
      margin-left: 5px;
      padding: 0px 4px;
    }

    &:hover {
      text-decoration: none !important;
    }

    &.avatar-tiny {
      font-size: 0.5625rem;
    }

    &.avatar-xs {
      font-size:  0.6875rem;
      padding-left: 1px;
      letter-spacing: 0.8px;
    }

    &.avatar-sm {
      font-size: 0.9375rem;
      padding-left: 1px;
      letter-spacing: 0.8px;
    }

    &.avatar-md {
      font-size: 40px;
    }

    &.avatar-lg {
      font-size: 38px;
    }
  }

  .avatar-lg {
    img {
      border: 3px solid white;
    }
  }

  .header {
    float: left;
    padding: 0px;
    margin: -5px 10px 0 0;
    border-radius: 30px;
  }

  .circle {
    border-radius: 50%;
  }
</style>

<template>
  <!--  -->
  <img
    :src="url"
    :width="width"
    :alt="name"
    v-if="url"
  ><span
    class="initials"
    v-text="initials"
    :style="{ background: background, height: width + 'px', width: width + 'px' }"
    v-else
  />
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    name: null,
    width: null,
    url: null,
  },

  data () {
    return {
      letters: 'abcdefghijklmnopqrstuvwxyz'.split(''),
    };
  },

  computed: {
    initials () {
      if (! this.name) {
        return ' ';
      }

      let first;
      const name = this.name.split(' ');
      const last = name[name.length - 1].charAt(0);

      for (let i = 0; i < name.length; i++) {
        if (this.isLetter(name[i].charAt(0))) {
          first = name[i].charAt(0);
          break;
        }
      }

      if (name.length === 1 || ! this.isLetter(last)) {
        return first ? first.toUpperCase() : ' ';
      }

      return (first + last).toUpperCase();
    },

    background () {
      if (! this.initials) {
        return window.colorFromString();
      }

      return window.colorFromString(this.initials);
    },
  },

  methods: {
    isLetter (str) {
      return this.letters.indexOf(str.charAt(0).toLowerCase()) > -1;
    },
  },
};
</script>
